import React from "react";
import { makeStyles } from "@material-ui/styles";
import { useSelector } from "react-redux";
import Typography from "@material-ui/core/Typography";
import moment from "moment";

const getColor = (status, theme) => {
  if (status === "paid") return theme.app.successColor;
  if (status === "confirmed") return theme.app.successColor;
  if (status === "queued") return theme.app.warningColor;
  if (status === "cancelled") return theme.app.dangerColor;
};

const getStatus = (booking) => {
  if (booking.isPaid) return "paid";
  if (booking.isConfirmed) return "confirmed";
  if (booking.isQueue && !booking.isCancelled) return "queued";
  if (booking.isCancelled) return "cancelled";
};

const getTime = (booking) => {
  const status = getStatus(booking);
  switch (status) {
    case "paid":
      return "";
    case "confirmed":
      return ` - ${moment(booking.confirmedAt).format("YYYY-MM-DD HH:mm")}`;
    case "queued":
      return "";
    case "cancelled":
      if (booking.confirmedAt === null && booking.cancelledAt) {
        return ` - ${moment(booking.cancelledAt).format("YYYY-MM-DD HH:mm")}`;
      } else if (booking.confirmedAt !== null) {
        return ` - ${moment(booking.confirmedAt).format("YYYY-MM-DD HH:mm")}`;
      }
    default:
      return "";
  }
};

const useStyles = makeStyles((theme) => ({
  status: {
    color: (p) => getColor(p.status, theme),
    textTransform: "uppercase",
    fontSize: "0.8125rem",
    marginTop: "4px",
    fontWeight: 500,
  },
}));

const Status = ({ booking }) => {
  const bookingStatus = getStatus(booking);
  const classes = useStyles({ status: bookingStatus });
  const language = useSelector((state) => state.language);

  return (
    <Typography className={classes.status}>
      {`${language.status[bookingStatus]}${getTime(booking)}`}
    </Typography>
  );
};

export default Status;
